export default __webpack_public_path__ + "static/media/singapore-onboarding-centre.24840667.jpg";